// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7ad32e27","213":"26f71092","239":"15030353","263":"983317ee","367":"989ee554","455":"8cabded9","484":"985f0efe","485":"6d9e2881","511":"b31c8f1f","564":"1960a52c","641":"3c13229b","768":"f6a4ea45","891":"36a0a932"}[chunkId] + ".chunk.js";
};